webpackJsonp([10],{

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(737)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(741),
  /* template */
  __webpack_require__(745),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-074b8cb7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(570), __esModule: true };

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(571);
module.exports = __webpack_require__(32).Object.keys;


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(89);
var $keys = __webpack_require__(126);

__webpack_require__(572)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(48);
var core = __webpack_require__(32);
var fails = __webpack_require__(85);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(574);
var objectAssign = __webpack_require__(575);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license Fraction.js v4.0.8 09/09/2015
 * http://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2015, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/


/**
 *
 * This class offers the possibility to calculate fractions.
 * You can pass a fraction in different formats. Either as array, as double, as string or as an integer.
 *
 * Array/Object form
 * [ 0 => <nominator>, 1 => <denominator> ]
 * [ n => <nominator>, d => <denominator> ]
 *
 * Integer form
 * - Single integer value
 *
 * Double form
 * - Single double value
 *
 * String form
 * 123.456 - a simple double
 * 123/456 - a string fraction
 * 123.'456' - a double with repeating decimal places
 * 123.(456) - synonym
 * 123.45'6' - a double with repeating last place
 * 123.45(6) - synonym
 *
 * Example:
 *
 * var f = new Fraction("9.4'31'");
 * f.mul([-4, 3]).div(4.9);
 *
 */

(function(root) {

  "use strict";

  // Maximum search depth for cyclic rational numbers. 2000 should be more than enough.
  // Example: 1/7 = 0.(142857) has 6 repeating decimal places.
  // If MAX_CYCLE_LEN gets reduced, long cycles will not be detected and toString() only gets the first 10 digits
  var MAX_CYCLE_LEN = 2000;

  // Parsed data to avoid calling "new" all the time
  var P = {
    "s": 1,
    "n": 0,
    "d": 1
  };

  function createError(name) {

    function errorConstructor() {
      var temp = Error.apply(this, arguments);
      temp['name'] = this['name'] = name;
      this['stack'] = temp['stack'];
      this['message'] = temp['message'];
    }

    /**
     * Error constructor
     *
     * @constructor
     */
    function IntermediateInheritor() {}
    IntermediateInheritor.prototype = Error.prototype;
    errorConstructor.prototype = new IntermediateInheritor();

    return errorConstructor;
  }

  var DivisionByZero = Fraction['DivisionByZero'] = createError('DivisionByZero');
  var InvalidParameter = Fraction['InvalidParameter'] = createError('InvalidParameter');

  function assign(n, s) {

    if (isNaN(n = parseInt(n, 10))) {
      throwInvalidParam();
    }
    return n * s;
  }

  function throwInvalidParam() {
    throw new InvalidParameter();
  }

  var parse = function(p1, p2) {

    var n = 0, d = 1, s = 1;
    var v = 0, w = 0, x = 0, y = 1, z = 1;

    var A = 0, B = 1;
    var C = 1, D = 1;

    var N = 10000000;
    var M;

    if (p1 === undefined || p1 === null) {
      /* void */
    } else if (p2 !== undefined) {
      n = p1;
      d = p2;
      s = n * d;
    } else
      switch (typeof p1) {

        case "object":
        {
          if ("d" in p1 && "n" in p1) {
            n = p1["n"];
            d = p1["d"];
            if ("s" in p1)
              n *= p1["s"];
          } else if (0 in p1) {
            n = p1[0];
            if (1 in p1)
              d = p1[1];
          } else {
            throwInvalidParam();
          }
          s = n * d;
          break;
        }
        case "number":
        {
          if (p1 < 0) {
            s = p1;
            p1 = -p1;
          }

          if (p1 % 1 === 0) {
            n = p1;
          } else if (p1 > 0) { // check for != 0, scale would become NaN (log(0)), which converges really slow

            if (p1 >= 1) {
              z = Math.pow(10, Math.floor(1 + Math.log(p1) / Math.LN10));
              p1 /= z;
            }

            // Using Farey Sequences
            // http://www.johndcook.com/blog/2010/10/20/best-rational-approximation/

            while (B <= N && D <= N) {
              M = (A + C) / (B + D);

              if (p1 === M) {
                if (B + D <= N) {
                  n = A + C;
                  d = B + D;
                } else if (D > B) {
                  n = C;
                  d = D;
                } else {
                  n = A;
                  d = B;
                }
                break;

              } else {

                if (p1 > M) {
                  A += C;
                  B += D;
                } else {
                  C += A;
                  D += B;
                }

                if (B > N) {
                  n = C;
                  d = D;
                } else {
                  n = A;
                  d = B;
                }
              }
            }
            n *= z;
          } else if (isNaN(p1) || isNaN(p2)) {
            d = n = NaN;
          }
          break;
        }
        case "string":
        {
          B = p1.match(/\d+|./g);

          if (B === null)
            throwInvalidParam();

          if (B[A] === '-') {// Check for minus sign at the beginning
            s = -1;
            A++;
          } else if (B[A] === '+') {// Check for plus sign at the beginning
            A++;
          }

          if (B.length === A + 1) { // Check if it's just a simple number "1234"
            w = assign(B[A++], s);
          } else if (B[A + 1] === '.' || B[A] === '.') { // Check if it's a decimal number

            if (B[A] !== '.') { // Handle 0.5 and .5
              v = assign(B[A++], s);
            }
            A++;

            // Check for decimal places
            if (A + 1 === B.length || B[A + 1] === '(' && B[A + 3] === ')' || B[A + 1] === "'" && B[A + 3] === "'") {
              w = assign(B[A], s);
              y = Math.pow(10, B[A].length);
              A++;
            }

            // Check for repeating places
            if (B[A] === '(' && B[A + 2] === ')' || B[A] === "'" && B[A + 2] === "'") {
              x = assign(B[A + 1], s);
              z = Math.pow(10, B[A + 1].length) - 1;
              A += 3;
            }

          } else if (B[A + 1] === '/' || B[A + 1] === ':') { // Check for a simple fraction "123/456" or "123:456"
            w = assign(B[A], s);
            y = assign(B[A + 2], 1);
            A += 3;
          } else if (B[A + 3] === '/' && B[A + 1] === ' ') { // Check for a complex fraction "123 1/2"
            v = assign(B[A], s);
            w = assign(B[A + 2], s);
            y = assign(B[A + 4], 1);
            A += 5;
          }

          if (B.length <= A) { // Check for more tokens on the stack
            d = y * z;
            s = /* void */
                    n = x + d * v + z * w;
            break;
          }

          /* Fall through on error */
        }
        default:
          throwInvalidParam();
      }

    if (d === 0) {
      throw new DivisionByZero();
    }

    P["s"] = s < 0 ? -1 : 1;
    P["n"] = Math.abs(n);
    P["d"] = Math.abs(d);
  };

  function modpow(b, e, m) {

    var r = 1;
    for (; e > 0; b = (b * b) % m, e >>= 1) {

      if (e & 1) {
        r = (r * b) % m;
      }
    }
    return r;
  }


  function cycleLen(n, d) {

    for (; d % 2 === 0;
            d /= 2) {
    }

    for (; d % 5 === 0;
            d /= 5) {
    }

    if (d === 1) // Catch non-cyclic numbers
      return 0;

    // If we would like to compute really large numbers quicker, we could make use of Fermat's little theorem:
    // 10^(d-1) % d == 1
    // However, we don't need such large numbers and MAX_CYCLE_LEN should be the capstone,
    // as we want to translate the numbers to strings.

    var rem = 10 % d;
    var t = 1;

    for (; rem !== 1; t++) {
      rem = rem * 10 % d;

      if (t > MAX_CYCLE_LEN)
        return 0; // Returning 0 here means that we don't print it as a cyclic number. It's likely that the answer is `d-1`
    }
    return t;
  }


     function cycleStart(n, d, len) {

    var rem1 = 1;
    var rem2 = modpow(10, len, d);

    for (var t = 0; t < 300; t++) { // s < ~log10(Number.MAX_VALUE)
      // Solve 10^s == 10^(s+t) (mod d)

      if (rem1 === rem2)
        return t;

      rem1 = rem1 * 10 % d;
      rem2 = rem2 * 10 % d;
    }
    return 0;
  }

  function gcd(a, b) {

    if (!a)
      return b;
    if (!b)
      return a;

    while (1) {
      a %= b;
      if (!a)
        return b;
      b %= a;
      if (!b)
        return a;
    }
  };

  /**
   * Module constructor
   *
   * @constructor
   * @param {number|Fraction=} a
   * @param {number=} b
   */
  function Fraction(a, b) {

    if (!(this instanceof Fraction)) {
      return new Fraction(a, b);
    }

    parse(a, b);

    if (Fraction['REDUCE']) {
      a = gcd(P["d"], P["n"]); // Abuse a
    } else {
      a = 1;
    }

    this["s"] = P["s"];
    this["n"] = P["n"] / a;
    this["d"] = P["d"] / a;
  }

  /**
   * Boolean global variable to be able to disable automatic reduction of the fraction
   *
   */
  Fraction['REDUCE'] = 1;

  Fraction.prototype = {

    "s": 1,
    "n": 0,
    "d": 1,

    /**
     * Calculates the absolute value
     *
     * Ex: new Fraction(-4).abs() => 4
     **/
    "abs": function() {

      return new Fraction(this["n"], this["d"]);
    },

    /**
     * Inverts the sign of the current fraction
     *
     * Ex: new Fraction(-4).neg() => 4
     **/
    "neg": function() {

      return new Fraction(-this["s"] * this["n"], this["d"]);
    },

    /**
     * Adds two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
     **/
    "add": function(a, b) {

      parse(a, b);
      return new Fraction(
              this["s"] * this["n"] * P["d"] + P["s"] * this["d"] * P["n"],
              this["d"] * P["d"]
              );
    },

    /**
     * Subtracts two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
     **/
    "sub": function(a, b) {

      parse(a, b);
      return new Fraction(
              this["s"] * this["n"] * P["d"] - P["s"] * this["d"] * P["n"],
              this["d"] * P["d"]
              );
    },

    /**
     * Multiplies two rational numbers
     *
     * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
     **/
    "mul": function(a, b) {

      parse(a, b);
      return new Fraction(
              this["s"] * P["s"] * this["n"] * P["n"],
              this["d"] * P["d"]
              );
    },

    /**
     * Divides two rational numbers
     *
     * Ex: new Fraction("-17.(345)").inverse().div(3)
     **/
    "div": function(a, b) {

      parse(a, b);
      return new Fraction(
              this["s"] * P["s"] * this["n"] * P["d"],
              this["d"] * P["n"]
              );
    },

    /**
     * Clones the actual object
     *
     * Ex: new Fraction("-17.(345)").clone()
     **/
    "clone": function() {
      return new Fraction(this);
    },

    /**
     * Calculates the modulo of two rational numbers - a more precise fmod
     *
     * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
     **/
    "mod": function(a, b) {

      if (isNaN(this['n']) || isNaN(this['d'])) {
        return new Fraction(NaN);
      }

      if (a === undefined) {
        return new Fraction(this["s"] * this["n"] % this["d"], 1);
      }

      parse(a, b);
      if (0 === P["n"] && 0 === this["d"]) {
        Fraction(0, 0); // Throw DivisionByZero
      }

      /*
       * First silly attempt, kinda slow
       *
       return that["sub"]({
       "n": num["n"] * Math.floor((this.n / this.d) / (num.n / num.d)),
       "d": num["d"],
       "s": this["s"]
       });*/

      /*
       * New attempt: a1 / b1 = a2 / b2 * q + r
       * => b2 * a1 = a2 * b1 * q + b1 * b2 * r
       * => (b2 * a1 % a2 * b1) / (b1 * b2)
       */
      return new Fraction(
              this["s"] * (P["d"] * this["n"]) % (P["n"] * this["d"]),
              P["d"] * this["d"]
              );
    },

    /**
     * Calculates the fractional gcd of two rational numbers
     *
     * Ex: new Fraction(5,8).gcd(3,7) => 1/56
     */
    "gcd": function(a, b) {

      parse(a, b);

      // gcd(a / b, c / d) = gcd(a, c) / lcm(b, d)

      return new Fraction(gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]), P["d"] * this["d"]);
    },

    /**
     * Calculates the fractional lcm of two rational numbers
     *
     * Ex: new Fraction(5,8).lcm(3,7) => 15
     */
    "lcm": function(a, b) {

      parse(a, b);

      // lcm(a / b, c / d) = lcm(a, c) / gcd(b, d)

      if (P["n"] === 0 && this["n"] === 0) {
        return new Fraction;
      }
      return new Fraction(P["n"] * this["n"], gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]));
    },

    /**
     * Calculates the ceil of a rational number
     *
     * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
     **/
    "ceil": function(places) {

      places = Math.pow(10, places || 0);

      if (isNaN(this["n"]) || isNaN(this["d"])) {
        return new Fraction(NaN);
      }
      return new Fraction(Math.ceil(places * this["s"] * this["n"] / this["d"]), places);
    },

    /**
     * Calculates the floor of a rational number
     *
     * Ex: new Fraction('4.(3)').floor() => (4 / 1)
     **/
    "floor": function(places) {

      places = Math.pow(10, places || 0);

      if (isNaN(this["n"]) || isNaN(this["d"])) {
        return new Fraction(NaN);
      }
      return new Fraction(Math.floor(places * this["s"] * this["n"] / this["d"]), places);
    },

    /**
     * Rounds a rational numbers
     *
     * Ex: new Fraction('4.(3)').round() => (4 / 1)
     **/
    "round": function(places) {

      places = Math.pow(10, places || 0);

      if (isNaN(this["n"]) || isNaN(this["d"])) {
        return new Fraction(NaN);
      }
      return new Fraction(Math.round(places * this["s"] * this["n"] / this["d"]), places);
    },

    /**
     * Gets the inverse of the fraction, means numerator and denumerator are exchanged
     *
     * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
     **/
    "inverse": function() {

      return new Fraction(this["s"] * this["d"], this["n"]);
    },

    /**
     * Calculates the fraction to some integer exponent
     *
     * Ex: new Fraction(-1,2).pow(-3) => -8
     */
    "pow": function(m) {

      if (m < 0) {
        return new Fraction(Math.pow(this['s'] * this["d"], -m), Math.pow(this["n"], -m));
      } else {
        return new Fraction(Math.pow(this['s'] * this["n"], m), Math.pow(this["d"], m));
      }
    },

    /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/
    "equals": function(a, b) {

      parse(a, b);
      return this["s"] * this["n"] * P["d"] === P["s"] * P["n"] * this["d"]; // Same as compare() === 0
    },

    /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/
    "compare": function(a, b) {

      parse(a, b);
      var t = (this["s"] * this["n"] * P["d"] - P["s"] * P["n"] * this["d"]);
      return (0 < t) - (t < 0);
    },
    
    "simplify": function(eps) {
      
      // First naive implementation, needs improvement
      
      if (isNaN(this['n']) || isNaN(this['d'])) {
        return this;
      }

      var cont = this['abs']()['toContinued']();
      
      eps = eps || 0.001;
      
      function rec(a) {
        if (a.length === 1)
          return new Fraction(a[0]);
        return rec(a.slice(1))['inverse']()['add'](a[0]);
      }
      
      for (var i = 0; i < cont.length; i++) {
        var tmp = rec(cont.slice(0, i + 1));
        if (tmp['sub'](this['abs']())['abs']().valueOf() < eps) {
          return tmp['mul'](this['s']);
        }
      }
      return this;
    },

    /**
     * Check if two rational numbers are divisible
     *
     * Ex: new Fraction(19.6).divisible(1.5);
     */
    "divisible": function(a, b) {

      parse(a, b);
      return !(!(P["n"] * this["d"]) || ((this["n"] * P["d"]) % (P["n"] * this["d"])));
    },

    /**
     * Returns a decimal representation of the fraction
     *
     * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
     **/
    'valueOf': function() {

      return this["s"] * this["n"] / this["d"];
    },

    /**
     * Returns a string-fraction representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toFraction() => "4 1/3"
     **/
    'toFraction': function(excludeWhole) {

      var whole, str = "";
      var n = this["n"];
      var d = this["d"];
      if (this["s"] < 0) {
        str += '-';
      }

      if (d === 1) {
        str += n;
      } else {

        if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
          str += whole;
          str += " ";
          n %= d;
        }

        str += n;
        str += '/';
        str += d;
      }
      return str;
    },

    /**
     * Returns a latex representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
     **/
    'toLatex': function(excludeWhole) {

      var whole, str = "";
      var n = this["n"];
      var d = this["d"];
      if (this["s"] < 0) {
        str += '-';
      }

      if (d === 1) {
        str += n;
      } else {

        if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
          str += whole;
          n %= d;
        }

        str += "\\frac{";
        str += n;
        str += '}{';
        str += d;
        str += '}';
      }
      return str;
    },

    /**
     * Returns an array of continued fraction elements
     *
     * Ex: new Fraction("7/8").toContinued() => [0,1,7]
     */
    'toContinued': function() {

      var t;
      var a = this['n'];
      var b = this['d'];
      var res = [];

      if (isNaN(this['n']) || isNaN(this['d'])) {
        return res;
      }

      do {
        res.push(Math.floor(a / b));
        t = a % b;
        a = b;
        b = t;
      } while (a !== 1);

      return res;
    },

    /**
     * Creates a string representation of a fraction with all digits
     *
     * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
     **/
    'toString': function() {

      var g;
      var N = this["n"];
      var D = this["d"];

      if (isNaN(N) || isNaN(D)) {
        return "NaN";
      }

      if (!Fraction['REDUCE']) {
        g = gcd(N, D);
        N /= g;
        D /= g;
      }

      var dec = 15; // 15 = decimal places when no repitation

      var cycLen = cycleLen(N, D); // Cycle length
      var cycOff = cycleStart(N, D, cycLen); // Cycle start

      var str = this['s'] === -1 ? "-" : "";

      str += N / D | 0;

      N %= D;
      N *= 10;

      if (N)
        str += ".";

      if (cycLen) {

        for (var i = cycOff; i--; ) {
          str += N / D | 0;
          N %= D;
          N *= 10;
        }
        str += "(";
        for (var i = cycLen; i--; ) {
          str += N / D | 0;
          N %= D;
          N *= 10;
        }
        str += ")";
      } else {
        for (var i = dec; N && i--; ) {
          str += N / D | 0;
          N %= D;
          N *= 10;
        }
      }
      return str;
    }
  };

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return Fraction;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === "object") {
    Object.defineProperty(exports, "__esModule", {'value': true});
    Fraction['default'] = Fraction;
    Fraction['Fraction'] = Fraction;
    module['exports'] = Fraction;
  } else {
    root['Fraction'] = Fraction;
  }

})(this);


/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(738);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("fb84a03e", content, true);

/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "body[data-v-074b8cb7]{margin:0;padding:0;width:100%;background:#f5f5f5;font-size:.675;-webkit-font-smoothing:antialiased;position:relative}table[data-v-074b8cb7]{border-collapse:collapse;width:100%}#teamHeader[data-v-074b8cb7]{width:100%;text-align:center;color:#fff;height:85px;font-size:0;background:url(" + __webpack_require__(739) + ") 0 0 no-repeat;background-size:cover}#teamHeader h3[data-v-074b8cb7]{padding-top:10px;margin:0;height:30px;line-height:30px;font-size:13px;text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#teamHeader div[data-v-074b8cb7]{display:inline-block;height:40px;line-height:40px;width:40%}#teamHeader div.left[data-v-074b8cb7]{text-align:right;font-size:16px}#teamHeader div.right[data-v-074b8cb7]{text-align:left;font-size:16px}#teamHeader div.mid[data-v-074b8cb7]{text-align:center;font-size:16px;width:19%}#teamHeader img[data-v-074b8cb7]{vertical-align:middle;width:26px;height:26px}nav[data-v-074b8cb7]{width:100%;margin:0 0 10px;padding:0;height:36px;line-height:36px;background:#fff;border-bottom:1px solid #ddd;font-size:0}nav span[data-v-074b8cb7]{display:inline-block;height:36px;line-height:36px;text-align:center;font-size:14.4px}nav span[data-v-074b8cb7]:first-child{width:25%}nav span[data-v-074b8cb7]:nth-child(2){width:73%}aside[data-v-074b8cb7]{width:25%;display:inline-block;vertical-align:top;font-size:1rem}aside span[data-v-074b8cb7]{display:block;height:40px;padding-bottom:2px;line-height:40px;font-size:14.4px;text-align:center;border-bottom:1px solid #ddd;border-right:1px solid #ddd;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}aside span.sel[data-v-074b8cb7]{color:#16ac3a;padding-bottom:0;border-bottom:2px solid #16c63a;border-right:0}article[data-v-074b8cb7]{width:71%;margin:0 1% 0 3%;display:inline-block;vertical-align:top;font-size:16px}.main[data-v-074b8cb7]{font-size:0;min-height:100%;letter-spacing:0;border-top:1px solid #ddd;background:#fff}.main article[data-v-074b8cb7]{background:url(" + __webpack_require__(740) + ") 0 0 repeat-x;background-size:100% auto;background-image:linear-gradient(180deg,#effff3,#8feba5)}.main article table[data-v-074b8cb7]{width:99%;margin:0 auto}.main article table tr td[data-v-074b8cb7]:first{width:16%}.main article table td[data-v-074b8cb7]{height:50px;position:relative;border-bottom:1px solid #b3dcbd;text-align:center;font-size:13px}.main td .frist[data-v-074b8cb7]{position:absolute;top:0;left:0;background:#ff6529;border-radius:3px;color:#fff;font-size:12px;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scale(.7);transform:scale(.7);padding:0 2px}span.text_lim[data-v-074b8cb7]{display:inline-block;white-space:nowrap;font-size:14px;height:14px;line-height:14px;line-break:strict;vertical-align:middle;overflow:hidden;width:90px;text-overflow:ellipsis}.firstTd[data-v-074b8cb7]{width:80px}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/pages/AppMatchOdds.vue"],"names":[],"mappings":"AACA,sBACE,SAAU,AACV,UAAW,AACX,WAAY,AACZ,mBAAoB,AACpB,eAAiB,AACjB,mCAAoC,AACpC,iBAAmB,CACpB,AACD,uBACE,yBAA0B,AAC1B,UAAY,CACb,AACD,6BACE,WAAY,AACZ,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,YAAa,AACb,uDAAgE,AAChE,qBAAuB,CACxB,AACD,gCACE,iBAAkB,AAClB,SAAU,AACV,YAAa,AACb,iBAAkB,AAClB,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACrB,AACD,iCACE,qBAAsB,AACtB,YAAa,AACb,iBAAkB,AAClB,SAAW,CACZ,AACD,sCACE,iBAAkB,AAClB,cAAgB,CACjB,AACD,uCACE,gBAAiB,AACjB,cAAgB,CACjB,AACD,qCACE,kBAAmB,AACnB,eAAgB,AAChB,SAAW,CACZ,AACD,iCACE,sBAAuB,AACvB,WAAY,AACZ,WAAa,CACd,AAID,qBACE,WAAY,AACZ,gBAAmB,AACnB,UAAW,AACX,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,6BAA8B,AAC9B,WAAa,CACd,AACD,0BACE,qBAAsB,AACtB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,gBAAkB,CACnB,AACD,sCACE,SAAW,CACZ,AACD,uCACE,SAAW,CACZ,AACD,uBACE,UAAW,AACX,qBAAsB,AACtB,mBAAoB,AACpB,cAAgB,CACjB,AACD,4BACE,cAAe,AACf,YAAa,AACb,mBAAoB,AACpB,iBAAkB,AAClB,iBAAkB,AAClB,kBAAmB,AACnB,6BAA8B,AAC9B,4BAA6B,AAC7B,mBAAoB,AACpB,gBAAiB,AACjB,sBAAwB,CACzB,AACD,gCACE,cAAe,AACf,iBAAkB,AAClB,gCAAiC,AACjC,cAAgB,CACjB,AACD,yBACE,UAAW,AACX,iBAAkB,AAClB,qBAAsB,AACtB,mBAAoB,AACpB,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,gBAAiB,AACjB,iBAAkB,AAClB,0BAA2B,AAC3B,eAAiB,CAClB,AACD,+BACE,sDAA2D,AAC3D,0BAA2B,AAC3B,wDAA+D,CAChE,AACD,qCACE,UAAW,AACX,aAAe,CAChB,AACD,iDACE,SAAW,CACZ,AACD,wCACE,YAAa,AACb,kBAAmB,AACnB,gCAAiC,AACjC,kBAAmB,AACnB,cAAgB,CACjB,AACD,iCACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,mBAAoB,AACpB,kBAAmB,AACnB,WAAY,AACZ,eAAgB,AAChB,6BAA8B,AACtB,qBAAsB,AAC9B,4BAA8B,AACtB,oBAAsB,AAC9B,aAAe,CAChB,AAQD,+BACE,qBAAsB,AACtB,mBAAoB,AACpB,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,sBAAuB,AACvB,gBAAiB,AACjB,WAAY,AACZ,sBAAwB,CACzB,AACD,0BACE,UAAY,CACb","file":"AppMatchOdds.vue","sourcesContent":["\nbody[data-v-074b8cb7] {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  background: #f5f5f5;\n  font-size: 0.675;\n  -webkit-font-smoothing: antialiased;\n  position: relative;\n}\ntable[data-v-074b8cb7] {\n  border-collapse: collapse;\n  width: 100%;\n}\n#teamHeader[data-v-074b8cb7] {\n  width: 100%;\n  text-align: center;\n  color: #fff;\n  height: 85px;\n  font-size: 0;\n  background: url('../assets/matchOdds/header.jpg') 0 0 no-repeat;\n  background-size: cover;\n}\n#teamHeader h3[data-v-074b8cb7] {\n  padding-top: 10px;\n  margin: 0;\n  height: 30px;\n  line-height: 30px;\n  font-size: 13px;\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n#teamHeader div[data-v-074b8cb7] {\n  display: inline-block;\n  height: 40px;\n  line-height: 40px;\n  width: 40%;\n}\n#teamHeader div.left[data-v-074b8cb7] {\n  text-align: right;\n  font-size: 16px;\n}\n#teamHeader div.right[data-v-074b8cb7] {\n  text-align: left;\n  font-size: 16px;\n}\n#teamHeader div.mid[data-v-074b8cb7] {\n  text-align: center;\n  font-size: 16px;\n  width: 19%;\n}\n#teamHeader img[data-v-074b8cb7] {\n  vertical-align: middle;\n  width: 26px;\n  height: 26px;\n}\n/*#listMain {\n    display: none;\n}*/\nnav[data-v-074b8cb7] {\n  width: 100%;\n  margin: 0 0 10px 0;\n  padding: 0;\n  height: 36px;\n  line-height: 36px;\n  background: #fff;\n  border-bottom: 1px solid #ddd;\n  font-size: 0;\n}\nnav span[data-v-074b8cb7] {\n  display: inline-block;\n  height: 36px;\n  line-height: 36px;\n  text-align: center;\n  font-size: 14.4px;\n}\nnav span[data-v-074b8cb7]:nth-child(1) {\n  width: 25%;\n}\nnav span[data-v-074b8cb7]:nth-child(2) {\n  width: 73%;\n}\naside[data-v-074b8cb7] {\n  width: 25%;\n  display: inline-block;\n  vertical-align: top;\n  font-size: 1rem;\n}\naside span[data-v-074b8cb7] {\n  display: block;\n  height: 40px;\n  padding-bottom: 2px;\n  line-height: 40px;\n  font-size: 14.4px;\n  text-align: center;\n  border-bottom: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\naside span.sel[data-v-074b8cb7] {\n  color: #16ac3a;\n  padding-bottom: 0;\n  border-bottom: 2px solid #16c63a;\n  border-right: 0;\n}\narticle[data-v-074b8cb7] {\n  width: 71%;\n  margin: 0 1% 0 3%;\n  display: inline-block;\n  vertical-align: top;\n  font-size: 16px;\n}\n.main[data-v-074b8cb7] {\n  font-size: 0;\n  min-height: 100%;\n  letter-spacing: 0;\n  border-top: 1px solid #ddd;\n  background: #fff;\n}\n.main article[data-v-074b8cb7] {\n  background: url('../assets/matchOdds/bg.png') 0 0 repeat-x;\n  background-size: 100% auto;\n  background-image: linear-gradient(to bottom, #effff3, #8feba5);\n}\n.main article table[data-v-074b8cb7] {\n  width: 99%;\n  margin: 0 auto;\n}\n.main article table tr td[data-v-074b8cb7]:first {\n  width: 16%;\n}\n.main article table td[data-v-074b8cb7] {\n  height: 50px;\n  position: relative;\n  border-bottom: 1px solid #b3dcbd;\n  text-align: center;\n  font-size: 13px;\n}\n.main td .frist[data-v-074b8cb7] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: #ff6529;\n  border-radius: 3px;\n  color: #fff;\n  font-size: 12px;\n  -webkit-transform-origin: 0 0;\n          transform-origin: 0 0;\n  -webkit-transform: scale(0.7);\n          transform: scale(0.7);\n  padding: 0 2px;\n}\n/*article table {\n    display: none;\n}\n\narticle table.show {\n    display: table;\n}*/\nspan.text_lim[data-v-074b8cb7] {\n  display: inline-block;\n  white-space: nowrap;\n  font-size: 14px;\n  height: 14px;\n  line-height: 14px;\n  line-break: strict;\n  vertical-align: middle;\n  overflow: hidden;\n  width: 90px;\n  text-overflow: ellipsis;\n}\n.firstTd[data-v-074b8cb7] {\n  width: 80px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header.3dc031f.jpg";

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg.2314cba.png";

/***/ }),

/***/ 741:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_oddsChanges__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_oddsChanges___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lang_oddsChanges__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_i18n__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);








var Fraction = __webpack_require__(576);


/* harmony default export */ __webpack_exports__["default"] = ({
    i18n: __WEBPACK_IMPORTED_MODULE_2__util_i18n__["a" /* default */],
    name: 'odds_changes',
    data: function data() {
        return {
            betList: [],
            currentSelectedCompanyIdIndex: 0,
            currentData: [],
            matchId: '',
            urlCompanyId: '',
            urlType: '',
            urlRate: ''
        };
    },

    computed: {
        teamData: {
            get: function get() {
                return this.$store.state.oddsChange || {};
            },
            set: function set(newValue) {
                this.$store.state.oddsChange = newValue;
            }
        }
    },
    created: function created() {
        var _this = this;

        var matchId = this.matchId = this.$route.query.matchId;
        var urlCompanyId = this.urlCompanyId = this.$route.query.companyId;
        var urlType = this.urlType = this.$route.query.type;
        var urlRate = this.urlRate = this.$route.query.rate;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_1__lang_oddsChanges___default.a).map(function (locale) {
            return __WEBPACK_IMPORTED_MODULE_2__util_i18n__["a" /* default */].setLocaleMessage(locale, __WEBPACK_IMPORTED_MODULE_1__lang_oddsChanges___default.a[locale]);
        });

        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(global.apiDomain + '/api/data/odds/detail/' + matchId + '?companyId=' + urlCompanyId + '&type=' + urlType + '&rate=' + urlRate + '&language=' + __WEBPACK_IMPORTED_MODULE_2__util_i18n__["a" /* default */].locale).then(function (res) {
            _this.teamData = res.data.teamData;
            if (res.data.betList) {
                _this.betList = res.data.betList;
                for (var i = 0; i < _this.betList.length; i++) {
                    if (urlCompanyId === _this.betList[i].company.companyId) {
                        _this.currentSelectedCompanyIdIndex = i;
                    }
                }
                _this.currentData = _this.betList[_this.currentSelectedCompanyIdIndex].company.detail;
            }
        }, function () {
            console.log('未获取到数据～');
        });
    },

    methods: {
        showDefault: function showDefault(team) {
            var defaultImg = __webpack_require__(744);
            event.target.src = defaultImg;
        },
        oddsFormat: function oddsFormat(odds) {
            var currentRate = this.urlRate;
            if (/^\d+(\.\d+)?$/.test(odds.toString())) {
                if (currentRate === 'American') {
                    if (odds >= 2) {
                        return Math.floor((odds - 1) * 100);
                    } else {
                        return Math.floor(100 / (1 - odds));
                    }
                }
                if (currentRate === 'Fractional') {
                    return new Fraction(odds).toFraction();
                }
            }
            return odds;
        },
        changeNav: function changeNav(companyId, index) {
            var _this2 = this;

            this.currentSelectedCompanyIdIndex = index;
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(global.apiDomain + '/api/data/odds/detail/' + this.matchId + '?companyId=' + companyId + '&type=' + this.urlType + '&rate=' + this.urlRate).then(function (res) {
                if (res.data.betList) {
                    _this2.currentData = res.data.betList[_this2.currentSelectedCompanyIdIndex].company.detail;
                }
            }, function () {
                console.log('未获取到数据～');
            });
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),

/***/ 742:
/***/ (function(module, exports) {

module.exports = {
    'en': {
        'odds_company': 'Company',
        'odds_dc': 'Detail Changes',
        'odds_initial': 'Initial'
    },
    'zh_cn': {
        'odds_company': 'zh_Company',
        'odds_dc': 'zh_Detail Changes',
        'odds_initial': 'zh_Initial'
    },
    'es': {
        'odds_company': 'Empresa',
        'odds_dc': 'El detalle cambia',
        'odds_initial': 'Inicial'
    },
    'pt': {
        'odds_company': 'Empresa',
        'odds_dc': 'Mudança de detalhes',
        'odds_initial': 'Inicial'
    },
    'it': {
        'odds_company': 'Società',
        'odds_dc': 'Cambiamenti Dettagli',
        'odds_initial': 'Iniziale'
    },
    'fr': {
        'odds_company': 'Compagnie',
        'odds_dc': 'Modifications de détails',
        'odds_initial': 'Initial'
    },
    'ru': {
        'odds_company': 'Компания',
        'odds_dc': 'Подробные изменения',
        'odds_initial': 'Начальный'
    },
    'tr': {
        'odds_company': '',
        'odds_dc': '',
        'odds_initial': ''
    },
    'in': {
        'odds_company': 'Perusahaan',
        'odds_dc': 'Perubahan Detail',
        'odds_initial': 'Awal'
    },
    'th': {
        'odds_company': 'บริษัท',
        'odds_dc': 'การเปลี่ยนแปลงรายละเอียด',
        'odds_initial': 'เริ่มต้น'
    },
    'de': {
        'odds_company': 'Unternehmen',
        'odds_dc': 'Detailänderungen',
        'odds_initial': 'Start'
    },
    'id': {
        'odds_company': 'Perusahaan',
        'odds_dc': 'Perubahan Detail',
        'odds_initial': 'Awal'
    },
    'ja': {
        'odds_company': '会社',
        'odds_dc': '詳細変更内容',
        'odds_initial': 'イニシャル'
    },
    'vi': {
        'odds_company': 'Công ty',
        'odds_dc': 'Thay đổi chi tiết',
        'odds_initial': 'Ban đầu'
    },
    'ar': {
        'odds_company': 'شركة',
        'odds_dc': 'تغييرات التفاصيل',
        'odds_initial': 'أولي'
    }
};

/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
    fallbackLocale: 'en'
});
i18n.locale = 'en';
/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/defaultTeam.1d25f26.png";

/***/ }),

/***/ 745:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "odds_changes"
    }
  }, [_c('div', {
    attrs: {
      "id": "teamHeader"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.teamData.matchTime) + " " + _vm._s(_vm.teamData.matchCompetition) + " Round " + _vm._s(_vm.teamData.matchRound))]), _vm._v(" "), (_vm.teamData.teamA) ? _c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "text_lim"
  }, [_vm._v(_vm._s(_vm.teamData.teamA.name))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.teamData.teamA.logo),
      "alt": ""
    },
    on: {
      "error": function($event) {
        _vm.showDefault($event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mid"
  }, [_vm._v("\n        VS\n    ")]), _vm._v(" "), (_vm.teamData.teamB) ? _c('div', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.teamData.teamB.logo),
      "alt": ""
    },
    on: {
      "error": function($event) {
        _vm.showDefault($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text_lim"
  }, [_vm._v(_vm._s(_vm.teamData.teamB.name))])]) : _vm._e()]), _vm._v(" "), _c('nav', [_c('span', [_vm._v(_vm._s(_vm.$t("odds_company")))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("odds_dc")))])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('aside', {
    staticClass: "menu"
  }, _vm._l((_vm.betList), function(item, index) {
    return _c('span', {
      key: index,
      class: {
        'sel': index === _vm.currentSelectedCompanyIdIndex
      },
      on: {
        "click": function($event) {
          _vm.changeNav(item.company.companyId, index)
        }
      }
    }, [_vm._v(_vm._s(item.company.name))])
  })), _vm._v(" "), _c('article', [_c('table', _vm._l((_vm.currentData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "firstTd"
    }, [(index == (_vm.currentData.length - 1)) ? _c('span', {
      staticClass: "frist"
    }, [_vm._v(_vm._s(_vm.$t("odds_initial")))]) : _vm._e(), _vm._v("\n                  " + _vm._s(_vm.oddsFormat(item.homeWin)) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat(item.draw)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.oddsFormat(item.awayWin)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.time))])])
  }))])])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.7b57f549a3fc2c2e4511.js